export const environment = {
  production: true,
  version: 'abe71ce8c7'
};
